import { TabManager } from '../../../../../../TabManager';

export const tabManager = TabManager.create();
